import React from "react";
import "./App.css";
import KubaMeridianWebsite from "./components/KubaMeridianWebsite";

function App() {
  return (
    <div className="App">
      <KubaMeridianWebsite />
    </div>
  );
}

export default App;
